import { getSomeDaysAgo } from '@/helpers/time';
import { useDataAverageAnalytic } from '@/hooks/useDataAverageAnalytic';
import useUserPlan from '@/hooks/useUserPlan';
import AverageRate, { IDataAverage } from '@/pages/Analytics/components/AverageRate';
import { mockDataAnalytics, mockDataProductAnalytic } from '@/pages/Analytics/sampleData';
import { apiCaller } from '@/redux/query';
import { Card, SkeletonBodyText } from '@shopify/polaris';
import { memo, useMemo } from 'react';

const now = new Date();
const startDate = getSomeDaysAgo(7);
const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

const Analytic = () => {
  const { isFreePlan } = useUserPlan();
  const { data: dataRes, isLoading } = apiCaller.useGetDataAnalyticQuery(
    {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    },
    { skip: isFreePlan },
  );
  const { data: productAnalyticRes } = apiCaller.useGetDataProductAnalyticQuery(undefined, { skip: isFreePlan });

  const data = useMemo(() => {
    return isFreePlan ? mockDataAnalytics : dataRes?.data || [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(dataRes), isFreePlan]);

  const dataProductAnalytic = useMemo(() => {
    return isFreePlan ? mockDataProductAnalytic : productAnalyticRes;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(productAnalyticRes), isFreePlan]);

  const dataAverageRate: IDataAverage = useDataAverageAnalytic(
    data,
    dataProductAnalytic?.appliedProducts,
    dataProductAnalytic?.totalActiveRules,
  );
  return isLoading ? (
    <Card>
      <SkeletonBodyText lines={6} />
    </Card>
  ) : (
    <AverageRate dataAverageRate={dataAverageRate} inHomePage />
  );
};

export default memo(Analytic);
